import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoaderState {
  count: number;
  message?: string;
}

const initialState: LoaderState = {
  count: 0,
  message: undefined,
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader: (state, action: PayloadAction<string | undefined>) => {
      state.count += 1;
      if (action.payload) state.message = action.payload;
    },
    hideLoader: (state) => {
      state.count = Math.max(0, state.count - 1);
      if (state.count === 0) state.message = undefined;
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;
export const loaderReducer = loaderSlice.reducer;

